module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/127.409b25b9.svg";